/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { SHOW_ERROR, CLEAR_ERROR } from "./types";

export interface IErrorMessage {
  message: string;
  component?: string;
}

export const showErrorAction = (error: IErrorMessage) => {
  return {
    type: SHOW_ERROR,
    error,
  };
};

export const clearErrorAction = () => {
  return {
    type: CLEAR_ERROR,
  };
};
